import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import Select from "react-select"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Badge,
  Row,
  Table,
  Input,
  Button,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormControl,
  Form,
  Label,
} from "reactstrap"
import { isEmpty, map, set, tap, toPairs } from "lodash"
//Import Breadcrumb
// import Breadcrumbs from "../../components/Common/Breadcrumb"

//Import Image
// import logo from "../../assets/images/Pham logo.png"
// import logo from "../../assets/images/ecs.png"
import logo from "../../assets/images/ecs.png"
// import logoLight from "../../assets/images/logo-light.png"
// import { getCourierDetail as onGetCourierDetail } from "../../store/invoices/actions"
//redux
import { useSelector, useDispatch } from "react-redux"
import axios from "axios"

import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { use } from "i18next"
import apiURl from "url"

const CourierDetail = props => {
  //meta title
  document.title = "ECS | Courier Detail"
  const { id } = useParams()
  const CID = id
  //Print

  const [printdata, setPrintdata] = useState("")

  const printInvoice = () => {
    const content = document.getElementById("print-data").innerHTML
    setPrintdata(content)

    axios
      .post(`${apiURl}/print`, { content })
      .then(response => {
        console.log(response.data)
      })
      .catch(error => {
        console.error("Error:", error)
      })
  }

  const navigate = useNavigate()

  const FullName = localStorage.getItem("full_name")
  const login_user_id = localStorage.getItem("login_user_id")
  const role = localStorage.getItem("role")
  const city = localStorage.getItem("city")

  const [trackId, setTrackId] = useState([])
  const [ParcelStatus, setParcelStatus] = useState([])

  const [Parcelinfo, SetParcelinfo] = useState([])
  const [orderNo, setOrderNo] = useState([])
  const [sname, setSname] = useState(null)
  const [sphone, setSphone] = useState(null)
  const [saddress, setSaddress] = useState(null)
  const [rname, setRname] = useState(null)
  const [rphone, setRphone] = useState(null)
  const [raddress, setRaddress] = useState(null)

  const [status, setStatus] = useState([])
  const [Edit, SetEdit] = useState(false)
  const [changedstatus, setChangedstatus] = useState("")

  const [assignStatus, setAssignStatus] = useState([])
  const [EditAssign, SetEditAssign] = useState(false)
  const [changeassignStatus, setChangeAssignStatus] = useState([])

  const [service, setService] = useState(null)
  const [DocSubService, setDocSubService] = useState(null)
  const [DepChargesName, setDepChargesName] = useState(null)
  const [DepChargesAmount, setDepChargesAmount] = useState(null)
  const [subservice, setSubservice] = useState(null)
  const [sector, setSector] = useState(null)

  const [DocumentMode, setDocumentMode] = useState(false)
  const [riders, setRiders] = useState([])
  const [RiderCode, setRiderCode] = useState([])
  const [riderCharges, setRiderCharges] = useState("0")
  const [documentDetail, setDocumentDetail] = useState(null)

  const [employee, setEmployee] = useState(null)
  const [paymentStatus, setPaymentStatus] = useState(null)

  const [AppRequest, setAppRequest] = useState(false)

  //Dispatch Detail
  const [LocationModal, setLocationModal] = useState(false)
  const [fromCity, setFromCity] = useState(null)
  const [ToCity, setToCity] = useState(null)
  const [DepChargesData, setDepChargesData] = useState([])
  const fetchParcelinfoByID = () => {
    const URL = `${apiURl}/fetchParcelDetailsByID`
    const id = { id: CID } // Wrap the id in an object
    axios
      .post(URL, id)
      .then(response => {
        if (response.data.status === "success") {
          setDepChargesData(response.data.parcelDetailsByID[0].dep_charges_data)
          setTrackId(response.data.parcelDetailsByID[0].track_id)
          setSname(response.data.parcelDetailsByID[0].sender_full_name)
          setSphone(response.data.parcelDetailsByID[0].sender_phone)
          setSaddress(response.data.parcelDetailsByID[0].sender_address)
          setRname(response.data.parcelDetailsByID[0].receiver_full_name)
          setRphone(response.data.parcelDetailsByID[0].receiver_phone)
          setRaddress(response.data.parcelDetailsByID[0].receiver_address)
          setRiderCharges(response.data.parcelDetailsByID[0].rider_charges)
          setAppRequest(response.data.parcelDetailsByID[0].req_id !== null)

          SetParcelinfo(response.data.parcelDetailsByID)
          setDocumentDetail(response.data.parcelDetailsByID[0].docs_detail)
          //Status
          setStatus(response.data.parcelDetailsByID[0].status_)
          setChangedstatus(response.data.parcelDetailsByID[0].status_)
          setPaymentStatus(response.data.parcelDetailsByID[0].payment_status)
          //Service Name
          setService(response.data.parcelDetailsByID[0].service_name)
          setDocSubService(response.data.parcelDetailsByID[0].doc_sub_service)
          setDepChargesName(response.data.parcelDetailsByID[0].dep_charges_type)
          setDepChargesAmount(
            response.data.parcelDetailsByID[0].dep_charges_amount
          )
          setSubservice(response.data.parcelDetailsByID[0].sub_service)
          setSector(response.data.parcelDetailsByID[0].sector_)

          setEmployee(response.data.parcelDetailsByID[0].employee_name)
          //Assign Status
          setAssignStatus(response.data.parcelDetailsByID[0].assign_status)
          setRiderCode(response.data.parcelDetailsByID[0].assign_rider)
          if (
            response.data.parcelDetailsByID[0].service_name ===
            "Docs. Attestation"
          ) {
            setDocumentMode(true)
          } else {
            setDocumentMode(false)
          }
        } else {
          console.error("Failed to fetch users:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error)
      })
  }

  const fetchParcelStatusByID = () => {
    const URL = `${apiURl}/fetchParcelStatusHistoryByID`
    const id = { id: CID }
    axios
      .post(URL, id)
      .then(response => {
        if (response.data.status === "success") {
          setParcelStatus(response.data.parcelStatusByID)
        } else {
          console.error("Failed to fetch users:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error)
      })
  }

  useEffect(() => {
    fetchParcelinfoByID()
    fetchParcelStatusByID()
  }, [])

  const handleEdit = id => {
    navigate(`/edit_courier_detail/${id}`)
  }

  const EditStatus = () => {
    SetEdit(!Edit)
  }

  //Update Status
  const UpdateStatus = e => {
    e.preventDefault()
    if (changedstatus === "") {
      toastr.error("SET Status")
    } else if (changedstatus === "dispatch") {
      if (fromCity === null) {
        toastr.error("Set From City")
      } else if (ToCity === null) {
        toastr.error("Set To City")
      } else {
        executeAxiosRequest()
      }
    } else {
      executeAxiosRequest()
    }
  }

  const executeAxiosRequest = () => {
    const data = {
      update_id: CID,
      track_id: trackId,
      status: changedstatus,
      City: city,
      FCity: fromCity,
      TCity: ToCity,
    }
    const URL = `${apiURl}/changeStatus`
    axios
      .post(URL, data)
      .then(response => {
        if (response.data.status === "success") {
          toastr.success("Status is Updated")
          fetchParcelinfoByID()
          fetchParcelStatusByID()
          setLocationModal(false)
          if (Edit) {
            SetEdit(!Edit)
          } else if (EditAssign) {
            SetEditAssign(!EditAssign)
          }
        } else {
          toastr.error("Error in Update", response.data.message)
        }
      })
      .catch(error => console.log(error))
  }

  //Update Assign Status
  const UpdateAssignStatus = () => {
    const data = {
      update_id: CID,
      assignStatus: changeassignStatus,
    }
    const URL = `${apiURl}/changeAssignStatus`
    axios
      .post(URL, data)
      .then(response => {
        if (response.data.status === "success") {
          toastr.success("Assign Status is Updated")
          fetchParcelinfoByID()
          fetchParcelStatusByID()

          if (Edit) {
            SetEdit(!Edit)
          } else if (EditAssign) {
            SetEditAssign(!EditAssign)
          }
        } else {
          toastr.error("Error in Update", response.data.message)
        }
      })
      .catch(error => console.log(error))
  }

  // Fetch riders data
  const getApprovedRiders = async () => {
    try {
      const URL = `${apiURl}/getApprovedRiders`
      const response = await axios.get(URL)

      if (response.data.status === "success") {
        setRiders(response.data.riders)
      } else {
        console.error("Failed to fetch riders:", response.data.message)
      }
    } catch (error) {
      console.error("Error fetching riders:", error)
    }
  }

  const EditAssignStatus = () => {
    SetEditAssign(!EditAssign)
  }

  useEffect(() => {
    getApprovedRiders()
  }, [])

  useEffect(() => {
    // Ensure Riders data is fetched and RiderCode is valid
    if (riders.length > 0 && RiderCode) {
      const Rider = riders.find(rider => rider.id === Number(RiderCode)) // Convert RiderCode to number for comparison
      if (Rider) {
        setChangeAssignStatus(Rider.id) // Set to rider ID (number)
      } else {
        console.warn(`Rider with ID ${RiderCode} not found in riders array.`)
        setChangeAssignStatus("") // Reset to empty string for no selection
      }
    }
  }, [riders, RiderCode])

  //
  const handleChangedStatus = event => {
    if (event.target.value === "dispatch") {
      setChangedstatus(event.target.value)
      setLocationModal(true)
    } else {
      setLocationModal(false)
      setChangedstatus(event.target.value)
    }
  }

  //
  const calculateTotalAmount = e => {
    const parcelAmount = parseFloat(e.total_price) || 0
    const documentAmount = parseFloat(e.docs_total_price) || 0
    const depChargesAmount = e.dep_charges_amount
      ? parseFloat(e.dep_charges_amount)
      : 0

    const parcelCviAmount = parseFloat(e.parcel_price) || 0
    const docCviAmount = parseFloat(e.doc_cvi_amount) || 0

    const parcelCviPercent = parcelCviAmount * 0.025
    const docCviPercent = docCviAmount * 0.025

    let PA_FOR_GST = (parcelAmount - parcelCviPercent) * 0.15 + parcelAmount
    let DA_FOR_GST = (documentAmount - docCviPercent) * 0.15 + documentAmount

    // ✅ Add depChargesAmount only if it exists
    // DA_FOR_GST += depChargesAmount;

    return e.service_name === "Docs. Attestation" ? DA_FOR_GST : PA_FOR_GST
  }

  // Determine badge text
  const isPaid = !paymentStatus || paymentStatus === "paid" // true if null or "paid"
  const PStatusView = isPaid ? "Paid" : "Not Paid"

  // Determine badge color
  const badgeClass =
    paymentStatus === "paid" || !paymentStatus ? "bg-success" : "bg-danger"

  return (
    <React.Fragment>
      {" "}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          {/* <Breadcrumbs title="Invoices" breadcrumbItem="Invoice Detail" /> */}

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="invoice-title">
                    {/* <div className="float-end">
                      <Button
                        className="btn btn-info btn-sm"
                        // onClick={() => handleEdit(CID)}
                      >
                        Edit
                      </Button>
                    </div> */}
                    <div className="d-inline-flex align-items-center mb-2">
                      <h4 className="font-size-16 mt-2 mr-2">
                        Courier Order # {CID}
                      </h4>
                      <Badge pill className={`mx-2 ${badgeClass}`}>
                        {PStatusView}
                      </Badge>
                    </div>
                  </div>
                  <hr />

                  <Row className="mb-3">
                    <Col md={6}>
                      <Card
                        className="h-100"
                        style={{
                          boxShadow:
                            "0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.08)",
                        }}
                      >
                        <CardBody>
                          <CardTitle className="fw-semibold text-primary mb-4">
                            <i className="bx bx-user-circle me-2"></i>Supplier
                            Information
                          </CardTitle>
                          <div className="info-section">
                            <div className="info-item mb-3">
                              <div className="d-flex align-items-center">
                                <span className="info-label fw-medium me-2">
                                  Name:
                                </span>
                                <span className="info-value">{sname}</span>
                              </div>
                            </div>
                            <div className="info-item mb-3">
                              <div className="d-flex align-items-center">
                                <span className="info-label fw-medium me-2">
                                  Phone:
                                </span>
                                <span className="info-value">{sphone}</span>
                              </div>
                            </div>
                            <div className="info-item">
                              <div className="d-flex align-items-start">
                                <span className="info-label fw-medium me-2">
                                  Address:
                                </span>
                                <span className="info-value">{saddress}</span>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={6}>
                      <Card
                        className="h-100"
                        style={{
                          boxShadow:
                            "0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.08)",
                        }}
                      >
                        <CardBody>
                          <CardTitle className="fw-semibold text-primary mb-4">
                            <i className="bx bx-package me-2"></i>Receiver
                            Information
                          </CardTitle>
                          <div className="info-section">
                            <div className="info-item mb-3">
                              <div className="d-flex align-items-center">
                                <span className="info-label fw-medium me-2">
                                  Name:
                                </span>
                                <span className="info-value">{rname}</span>
                              </div>
                            </div>
                            <div className="info-item mb-3">
                              <div className="d-flex align-items-center">
                                <span className="info-label fw-medium me-2">
                                  Phone:
                                </span>
                                <span className="info-value">{rphone}</span>
                              </div>
                            </div>
                            <div className="info-item">
                              <div className="d-flex align-items-start">
                                <span className="info-label fw-medium me-2">
                                  Address:
                                </span>
                                <span className="info-value">{raddress}</span>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row className="mb-5">
                    <Col md={6}>
                      <Card
                        className="h-100"
                        style={{
                          boxShadow:
                            "0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.08)",
                        }}
                      >
                        <CardBody>
                          <CardTitle className="fw-semibold text-primary mb-4">
                            <i className="bx bx-cog me-2"></i>Actions
                          </CardTitle>

                          {AppRequest && (
                            <div className="action-item mb-4">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="fw-semibold mb-0">
                                  Assign Rider
                                </h6>

                                {!Edit && (
                                  <Button
                                    variant="link"
                                    color="primary"
                                    size="sm"
                                    onClick={EditAssignStatus}
                                    className="p-0"
                                  >
                                    <i className="bx bx-edit font-size-16"></i>
                                  </Button>
                                )}
                              </div>

                              {EditAssign ? (
                                <FormGroup>
                                  <select
                                    value={changeassignStatus || ""}
                                    onChange={e =>
                                      setChangeAssignStatus(e.target.value)
                                    }
                                    className="form-select-sm"
                                  >
                                    <option value="">Select Rider...</option>
                                    {riders.length > 0 ? (
                                      riders
                                        .filter(e => !!e)
                                        .map((e, index) => (
                                          <option key={index} value={e.id}>
                                            {e.name}
                                          </option>
                                        ))
                                    ) : (
                                      <option disabled>
                                        No riders available
                                      </option>
                                    )}
                                  </select>
                                </FormGroup>
                              ) : (
                                <div className="status-badge">
                                  {assignStatus === "NotAssign" ? (
                                    <Badge pill className="bg-danger px-3 py-1">
                                      Not Assigned
                                    </Badge>
                                  ) : (
                                    <Badge
                                      pill
                                      className="bg-success px-3 py-1"
                                    >
                                      Assigned
                                    </Badge>
                                  )}
                                </div>
                              )}
                            </div>
                          )}

                          {/* Status Change Section */}
                          <div className="action-item">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6 className="fw-semibold mb-0">
                                Change Status
                              </h6>
                              {!EditAssign && (
                                <Button
                                  variant="link"
                                  size="sm"
                                  color="primary"
                                  onClick={EditStatus}
                                  className="p-0"
                                >
                                  <i className="bx bx-edit font-size-16"></i>
                                </Button>
                              )}
                            </div>

                            {Edit ? (
                              <FormGroup>
                                <select
                                  value={changedstatus}
                                  onChange={handleChangedStatus}
                                  className="form-select-sm"
                                >
                                  {(() => {
                                    switch (status) {
                                      case "new":
                                        return (
                                          <>
                                            <option value={""}>
                                              Select ...
                                            </option>
                                            <option value="in-progress">
                                              In Progress
                                            </option>
                                            <option value="dispatch">
                                              Dispatch
                                            </option>
                                            <option value="foreign-office-submit">
                                              Submitted to Foreign office
                                            </option>
                                            <option value="collect">
                                              Ready To Collect
                                            </option>
                                            <option value="delivered">
                                              Delivered
                                            </option>
                                            <option value="resubmit">
                                              Resubmit
                                            </option>
                                            <option value="cancel">
                                              Cancel
                                            </option>
                                          </>
                                        )
                                      case "in-progress":
                                        return (
                                          <>
                                            <option value={""}>
                                              Select ...
                                            </option>
                                            <option value="dispatch">
                                              Dispatch
                                            </option>
                                            <option value="foreign-office-submit">
                                              Submitted to Foreign office
                                            </option>
                                            <option value="collect">
                                              Ready To Collect
                                            </option>
                                            <option value="delivered">
                                              Delivered
                                            </option>
                                            <option value="resubmit">
                                              Resubmit
                                            </option>
                                            <option value="cancel">
                                              Cancel
                                            </option>
                                          </>
                                        )
                                      case "dispatch":
                                        return (
                                          <>
                                            <option value={""}>
                                              Select ...
                                            </option>
                                            <option value="foreign-office-submit">
                                              Submitted to Foreign office
                                            </option>
                                            <option value="collect">
                                              Ready To Collect
                                            </option>
                                            <option value="delivered">
                                              Delivered
                                            </option>
                                            <option value="resubmit">
                                              Resubmit
                                            </option>
                                            <option value="cancel">
                                              Cancel
                                            </option>
                                          </>
                                        )
                                      case "foreign-office-submit":
                                        return (
                                          <>
                                            <option value={""}>
                                              Select ...
                                            </option>

                                            <option value="collect">
                                              Ready To Collect
                                            </option>
                                            <option value="delivered">
                                              Delivered
                                            </option>
                                            <option value="resubmit">
                                              Resubmit
                                            </option>
                                            <option value="cancel">
                                              Cancel
                                            </option>
                                          </>
                                        )
                                      case "collect":
                                        return (
                                          <>
                                            <option value={""}>
                                              Select ...
                                            </option>
                                            <option value="delivered">
                                              Delivered
                                            </option>
                                            <option value="resubmit">
                                              Resubmit
                                            </option>
                                            <option value="cancel">
                                              Cancel
                                            </option>
                                          </>
                                        )

                                      case "delivered":
                                        return (
                                          <>
                                            <option value={""}>
                                              Select ...
                                            </option>
                                            <option value="resubmit">
                                              Resubmit
                                            </option>
                                            <option value="cancel">
                                              Cancel
                                            </option>
                                          </>
                                        )
                                      case "resubmit":
                                        return (
                                          <>
                                            <option value="">
                                              Select ...{" "}
                                            </option>
                                            <option value="in-progress">
                                              In Progress
                                            </option>
                                            <option value="dispatch">
                                              Dispatch
                                            </option>
                                            <option value="foreign-office-submit">
                                              Submitted to Foreign office
                                            </option>
                                            <option value="collect">
                                              Ready To Collect
                                            </option>
                                            <option value="delivered">
                                              Delivered
                                            </option>
                                            <option value="resubmit">
                                              Resubmit
                                            </option>
                                          </>
                                        )
                                      case "cancel":
                                        return (
                                          <>
                                            <option value="">
                                              Select ...{" "}
                                            </option>
                                            <option value="in-progress">
                                              In Progress
                                            </option>
                                            <option value="dispatch">
                                              Dispatch
                                            </option>
                                            <option value="foreign-office-submit">
                                              Submitted to Foreign office
                                            </option>
                                            <option value="collect">
                                              Ready To Collect
                                            </option>
                                            <option value="delivered">
                                              Delivered
                                            </option>
                                            <option value="resubmit">
                                              Resubmit
                                            </option>
                                          </>
                                        )
                                      default:
                                        return null
                                    }
                                  })()}
                                </select>
                              </FormGroup>
                            ) : (
                              <div className="status-badge">
                                {(() => {
                                  switch (status) {
                                    case "new":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-info px-3 py-1"
                                        >
                                          New
                                        </Badge>
                                      )
                                    case "cancel":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-danger  px-3 py-1"
                                        >
                                          Cancel
                                        </Badge>
                                      )
                                    case "in-progress":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-warning px-3 py-1"
                                        >
                                          In Progress
                                        </Badge>
                                      )
                                    case "dispatch":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-warning px-3 py-1"
                                        >
                                          Dispatch
                                        </Badge>
                                      )
                                    case "foreign-office-submit":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-warning px-3 py-1"
                                        >
                                          Submitted to Foreign office
                                        </Badge>
                                      )
                                    case "collect":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-success px-3 py-1"
                                        >
                                          Ready To Collect
                                        </Badge>
                                      )
                                    case "delivered":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-success px-3 py-1"
                                        >
                                          Delivered
                                        </Badge>
                                      )
                                    case "resubmit":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-secondary px-3 py-1"
                                        >
                                          Resubmit
                                        </Badge>
                                      )
                                    default:
                                      return null
                                  }
                                })()}
                              </div>
                            )}
                          </div>

                          <div className="d-print-none">
                            {Edit && (
                              <div className="float-end">
                                <Button
                                  color="secondary"
                                  className="btn btn-sm btn-secondary waves-effect waves-light gap-2"
                                  onClick={UpdateStatus}
                                >
                                  Update Status
                                </Button>
                              </div>
                            )}
                            {EditAssign && (
                              <div className="float-end">
                                <Button
                                  color="secondary"
                                  className="btn btn-sm btn-secondary waves-effect waves-light gap-2"
                                  onClick={UpdateAssignStatus}
                                >
                                  Update Rider
                                </Button>
                              </div>
                            )}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    {/* Service Details Section */}
                    <Col md={6}>
                      <Card
                        className="h-100"
                        style={{
                          boxShadow:
                            "0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.08)",
                        }}
                      >
                        <CardBody>
                          <CardTitle className="fw-semibold text-primary mb-4">
                            <i className="bx bx-detail me-2"></i>
                            {DocumentMode
                              ? "Document Details"
                              : "Service Details"}
                          </CardTitle>

                          {!DocumentMode ? (
                            <div className="info-section">
                              <div className="info-item mb-3">
                                <div className="d-flex align-items-center">
                                  <span className="info-label fw-medium me-2">
                                    Service:
                                  </span>
                                  <span className="info-value">{service}</span>
                                </div>
                              </div>
                              <div className="info-item mb-3">
                                <div className="d-flex align-items-center">
                                  <span className="info-label fw-medium me-2">
                                    Sub Service:
                                  </span>
                                  <span className="info-value text-capitalize">
                                    {subservice === "overnight"
                                      ? "Over Night"
                                      : subservice === "flyer"
                                      ? "Flyer"
                                      : subservice === "box"
                                      ? "Box"
                                      : subservice}
                                  </span>
                                </div>
                              </div>
                              <div className="info-item">
                                <div className="d-flex align-items-center">
                                  <span className="info-label fw-medium me-2">
                                    Sector:
                                  </span>
                                  <span className="info-value">
                                    {sector === "wc"
                                      ? "Within City"
                                      : sector === "sz"
                                      ? "Same Zone"
                                      : sector === "dz"
                                      ? "Different Zone"
                                      : sector}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="info-section">
                              <div className="info-item mb-3">
                                <div className="d-flex align-items-center">
                                  <span className="info-label fw-medium me-2">
                                    Service:
                                  </span>
                                  <span className="info-value">{service}</span>
                                </div>
                              </div>
                              <div className="info-item mb-3">
                                <div className="d-flex align-items-center">
                                  <span className="info-label fw-medium me-2">
                                    Sub Service:
                                  </span>
                                  <span className="info-value">
                                    {DocSubService}
                                  </span>
                                </div>
                              </div>
                              <div className="info-item">
                                <FormGroup>
                                  <Label className="fw-medium">
                                    Document Details
                                  </Label>
                                  <Input
                                    as="textarea"
                                    rows={3}
                                    value={documentDetail}
                                    disabled
                                    className="bg-light"
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  {DepChargesData.length > 0 && (
                    <>
                      <div className="py-2 mt-3">
                        <h3 className="font-size-15 fw-bold">
                          Department Charges Types Document
                        </h3>
                      </div>
                      <div className="table-responsive">
                        <Table
                          className="table-nowrap"
                          style={{ border: "1px solid #63719c" }}
                        >
                          <thead style={{ backgroundColor: "#F5F5F9" }}>
                            <tr>
                              <th>No.</th>
                              <th>Type</th>
                              <th>No. Of Documnets</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {DepChargesData.length > 0 ? (
                              <>
                                {DepChargesData.filter(e => !!e).map(
                                  (e, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <b>{e.dep_charges_type}</b>{" "}
                                      </td>
                                      <td>{e.dep_charges_doc_no} </td>
                                      <td>
                                        {parseFloat(
                                          e.dep_charge_amount
                                        ).toLocaleString("en-US", {
                                          style: "currency",
                                          currency: "PKR",
                                        })}{" "}
                                      </td>
                                    </tr>
                                  )
                                )}
                                <tr
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#e0e0e0",
                                  }}
                                >
                                  <td
                                    colSpan={3}
                                    style={{ textAlign: "right" }}
                                  >
                                    Total:
                                  </td>
                                  <td>
                                    {DepChargesData.reduce(
                                      (sum, e) =>
                                        sum + Number(e.dep_charge_amount),
                                      0
                                    ).toLocaleString("en-US", {
                                      style: "currency",
                                      currency: "PKR",
                                    })}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <tr>
                                <td>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </>
                  )}

                  {DocumentMode ? (
                    <>
                      <div className="py-2 mt-3">
                        <h3 className="font-size-15 fw-bold">
                          Documents summary
                        </h3>
                      </div>
                      <div className="table-responsive">
                        <Table
                          className="table-nowrap"
                          style={{ border: "1px solid #63719c" }}
                        >
                          <thead style={{ backgroundColor: "#F5F5F9" }}>
                            <tr>
                              <th>Track ID</th>
                              <th>Docs Deliver</th>
                              <th>Docs City Option</th>
                              <th>No. Of Docs</th>
                              <th>Service Charges</th>
                              <th>Dep Charges</th>

                              {riderCharges !== "0" &&
                                riderCharges !== null &&
                                riderCharges !== undefined && (
                                  <th>Rider Charges</th>
                                )}
                              <th>CVI</th>

                              <th>CVI Amount</th>
                              {AppRequest && <th>Assign Status</th>}
                              <th>Courier Status</th>
                              <th>Booking Data</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Parcelinfo.length > 0 ? (
                              Parcelinfo.filter(e => !!e).map((e, index) => (
                                <tr key={index}>
                                  <td>{e.track_id}</td>
                                  <td>
                                    {(() => {
                                      switch (e.docs_office_type) {
                                        case "oto_":
                                          return " Office To Office"
                                        case "otd_":
                                          return "Office To Door"
                                        default:
                                          return "Unknown"
                                      }
                                    })()}
                                  </td>
                                  <td>
                                    {(() => {
                                      switch (e.docs_city_type) {
                                        case "wc_":
                                          return "Within City"
                                        case "ctc_":
                                          return "City To City"
                                        default:
                                          return "Unknown"
                                      }
                                    })()}
                                  </td>
                                  <td>{e.no_of_docs}</td>
                                  <td>
                                    <td>
                                      {calculateTotalAmount(e).toLocaleString(
                                        "en-US",
                                        { style: "currency", currency: "PKR" }
                                      )}
                                    </td>
                                  </td>

                                  <td>
                                    {e.dep_charges_amount == null
                                      ? "None"
                                      : parseFloat(
                                          e.dep_charges_amount
                                        ).toLocaleString("en-US", {
                                          style: "currency",
                                          currency: "PKR",
                                        })}
                                  </td>
                                  {riderCharges !== "0" &&
                                    riderCharges !== null &&
                                    riderCharges !== undefined && (
                                      <td>
                                        {(() => {
                                          switch (riderCharges) {
                                            case null:
                                            case undefined:
                                            case "0":
                                              return "0.00"
                                            default:
                                              return parseFloat(
                                                riderCharges
                                              ).toLocaleString("en-US", {
                                                style: "currency",
                                                currency: "PKR",
                                              })
                                          }
                                        })()}
                                      </td>
                                    )}

                                  <td>
                                    {(() => {
                                      switch (e.docs_cvi_value) {
                                        case "1":
                                          return "Done"
                                        case "0":
                                          return "None"
                                        default:
                                          return "Unknown"
                                      }
                                    })()}
                                  </td>
                                  <td>
                                    {parseFloat(
                                      e.doc_cvi_amount
                                    ).toLocaleString("en-US", {
                                      style: "currency",
                                      currency: "PKR",
                                    })}
                                  </td>
                                  {AppRequest && (
                                    <td>
                                      {(() => {
                                        switch (e.assign_status) {
                                          case "NotAssign":
                                            return (
                                              <Badge
                                                pill
                                                className="bg-danger font-size-10"
                                              >
                                                Not Assigned
                                              </Badge>
                                            )
                                          case "assigned":
                                            return (
                                              <Badge
                                                pill
                                                className="bg-success font-size-10"
                                              >
                                                Assigned
                                              </Badge>
                                            )
                                          default:
                                            return "Unknown"
                                        }
                                      })()}
                                    </td>
                                  )}

                                  <td>
                                    {(() => {
                                      switch (e.status_) {
                                        case "new":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-info font-size-12"
                                            >
                                              New
                                            </Badge>
                                          )
                                        case "cancel":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-danger font-size-12"
                                            >
                                              Cancel
                                            </Badge>
                                          )
                                        case "in-progress":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-warning font-size-12"
                                            >
                                              In Progress
                                            </Badge>
                                          )
                                        case "foreign-office-submit":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-warning font-size-12"
                                            >
                                              Submitted to Foreign Office
                                            </Badge>
                                          )
                                        case "collect":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-success font-size-12"
                                            >
                                              Ready to Collect
                                            </Badge>
                                          )
                                        case "dispatch":
                                          return (
                                            <>
                                              {" "}
                                              <Badge
                                                pill
                                                className="bg-warning font-size-12"
                                              >
                                                Dispatch {""}
                                              </Badge>
                                              (
                                              {`${e.from_location} -${e.to_location} `}
                                              )
                                            </>
                                          )
                                        case "resubmit":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-secndory font-size-12"
                                            >
                                              Resubmit
                                            </Badge>
                                          )
                                        case "delivered":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-success font-size-12"
                                            >
                                              Deliverd
                                            </Badge>
                                          )
                                      }
                                    })()}
                                  </td>
                                  <td>{e.created_date}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="py-2 mt-3">
                        <h3 className="font-size-15 fw-bold">Parcel summary</h3>
                      </div>
                      <div className="table-responsive">
                        <Table
                          className="table-nowrap"
                          style={{ border: "1px solid #63719c" }}
                        >
                          <thead style={{ backgroundColor: "#F5F5F9" }}>
                            <tr>
                              <th>Track ID</th>
                              <th>No. Of Content</th>
                              <th>Content Weight</th>
                              <th>Content Value</th>
                              <th>CVI</th>
                              {AppRequest && <th>Assign Status</th>}
                              <th>Courier Status</th>
                              <th>Booking Data</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Parcelinfo.length > 0 ? (
                              Parcelinfo.filter(e => !!e).map((e, index) => (
                                <tr key={index}>
                                  <td>{e.track_id}</td>
                                  <td>{e.no_of_products}</td>
                                  <td>{e.parcel_weight} (Kg)</td>
                                  <td>
                                    {(() => {
                                      switch (e.parcel_price) {
                                        case "":
                                          return "0.00"
                                        case "0":
                                          return "0.00"
                                        default:
                                          return parseFloat(
                                            e.parcel_price
                                          ).toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "PKR",
                                          })
                                      }
                                    })()}
                                  </td>
                                  <td>
                                    {(() => {
                                      switch (e.parcel_cvi_value) {
                                        case "1":
                                          return "Done"
                                        case "0":
                                          return "None"
                                        default:
                                          return "Unknown"
                                      }
                                    })()}
                                  </td>
                                  {AppRequest && (
                                    <td>
                                      {(() => {
                                        switch (e.assign_status) {
                                          case "NotAssign":
                                            return (
                                              <Badge
                                                pill
                                                className="bg-danger font-size-10"
                                              >
                                                Not Assigned
                                              </Badge>
                                            )
                                          case "assigned":
                                            return (
                                              <Badge
                                                pill
                                                className="bg-success font-size-10"
                                              >
                                                Assigned
                                              </Badge>
                                            )
                                          default:
                                            return "Unknown"
                                        }
                                      })()}
                                    </td>
                                  )}

                                  <td>
                                    {(() => {
                                      switch (e.status_) {
                                        case "new":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-info font-size-12"
                                            >
                                              New
                                            </Badge>
                                          )
                                        case "cancel":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-danger font-size-12"
                                            >
                                              Cancel
                                            </Badge>
                                          )
                                        case "in-progress":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-warning font-size-12"
                                            >
                                              In Progress
                                            </Badge>
                                          )
                                        case "foreign-office-submit":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-warning font-size-12"
                                            >
                                              Submitted to Foreign Office
                                            </Badge>
                                          )
                                        case "collect":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-success font-size-12"
                                            >
                                              Ready to Collect
                                            </Badge>
                                          )
                                        case "dispatch":
                                          return (
                                            <>
                                              {" "}
                                              <Badge
                                                pill
                                                className="bg-warning font-size-12"
                                              >
                                                Dispatch {""}
                                              </Badge>
                                              (
                                              {`${e.from_location} -${e.to_location} `}
                                              )
                                            </>
                                          )
                                        case "resubmit":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-secndory font-size-12"
                                            >
                                              Resubmit
                                            </Badge>
                                          )
                                        case "delivered":
                                          return (
                                            <Badge
                                              pill
                                              className="bg-success font-size-12"
                                            >
                                              Deliverd
                                            </Badge>
                                          )
                                      }
                                    })()}
                                  </td>
                                  <td>{e.created_date}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </>
                  )}

                  <div className="py-2 mt-3">
                    <h3 className="font-size-15 fw-bold">Status summary</h3>
                  </div>
                  <div className="table-responsive">
                    <Table
                      className="table-nowrap"
                      style={{ border: "1px solid #63719c" }}
                    >
                      <thead style={{ backgroundColor: "#F5F5F9" }}>
                        <tr>
                          <th>Track ID</th>
                          <th>All Status</th>
                          <th>Current City</th>
                          <th>Status Time</th>
                          <th>Status Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ParcelStatus.length > 0 ? (
                          ParcelStatus.filter(e => !!e).map((e, index) => (
                            <tr key={index}>
                              <td>{e.track_id}</td>
                              <td>
                                {(() => {
                                  switch (e.parcel_status) {
                                    case "new":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-info font-size-12"
                                        >
                                          New
                                        </Badge>
                                      )
                                    case "cancel":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-danger font-size-12"
                                        >
                                          Cancel
                                        </Badge>
                                      )
                                    case "in-progress":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-warning font-size-12"
                                        >
                                          In Progress
                                        </Badge>
                                      )
                                    case "foreign-office-submit":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-warning font-size-12"
                                        >
                                          Submitted to Foreign Office
                                        </Badge>
                                      )
                                    case "collect":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-success font-size-12"
                                        >
                                          Ready to Collect
                                        </Badge>
                                      )
                                    case "dispatch":
                                      return (
                                        <>
                                          {" "}
                                          <Badge
                                            pill
                                            className="bg-warning font-size-12"
                                          >
                                            Dispatch {""}
                                          </Badge>
                                          (
                                          {`${e.from_location} -${e.to_location} `}
                                          )
                                        </>
                                      )
                                    case "resubmit":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-secndory font-size-12"
                                        >
                                          Resubmit
                                        </Badge>
                                      )
                                    case "delivered":
                                      return (
                                        <Badge
                                          pill
                                          className="bg-success font-size-12"
                                        >
                                          Deliverd
                                        </Badge>
                                      )
                                  }
                                })()}
                              </td>
                              <td>{e.parcel_location} </td>
                              <td>{e.parcel_time} </td>
                              <td>{e.parcel_date} </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td>No Data Found</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          isOpen={LocationModal}
          role="dialog"
          size="md"
          autoFocus={true}
          centered={true}
          className="exampleModal"
          tabIndex="-1"
          toggle={() => {
            setLocationModal(!LocationModal)
          }}
        >
          <div>
            <Form>
              <ModalHeader
                toggle={() => {
                  setLocationModal(!LocationModal)
                }}
              >
                Dispatch Detail
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <label>From City *</label>
                      <Input
                        className="form-control"
                        type="text"
                        placeholder="From City"
                        name="user_name"
                        value={fromCity}
                        onChange={e => setFromCity(e.target.value)}
                      ></Input>
                    </div>
                    <div className="mb-3">
                      <label>To City *</label>
                      <Input
                        className="form-control"
                        type="text"
                        placeholder="To City"
                        name="user_city"
                        value={ToCity}
                        onChange={e => setToCity(e.target.value)}
                      ></Input>
                    </div>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  color="secondary"
                  onClick={() => {
                    setLocationModal(!LocationModal)
                    setFromCity(null)
                    setToCity(null)
                  }}
                >
                  Close
                </Button>
                <Button color="primary" onClick={UpdateStatus}>
                  Submit
                </Button>
              </ModalFooter>
            </Form>
          </div>
        </Modal>

        <div id="print-data" style={{ display: "none" }}>
          <div className="text-center">Printed Data</div>
        </div>
      </div>
    </React.Fragment>
  )
}

CourierDetail.propTypes = {
  match: PropTypes.any,
}

export default withRouter(CourierDetail)
